import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, ElementRef } from '@angular/core';

import { IConta } from '../../../../../../shared/interfaces/conta.interface';
import { ICartao } from '../../../../../../shared/interfaces/cartao.interface';
import { IEndereco } from '../../../../../../shared/interfaces/endereco.interface';
import { IAdquirente } from '../../../../../../shared/interfaces/adquirente.interface';

import { Conta } from '../../../../../../shared/models/conta';
import { Cartao } from '../../../../../../shared/models/cartao';
import { Endereco } from '../../../../../../shared/models/endereco';
import { Adquirente } from '../../../../../../shared/models/adquirente';

import { ContaService } from '../../../../../../shared/services/conta/conta.service';
import { EventEmitterService } from '../../../../../../shared/services/event-emitter/event-emitter.service';
import { LocalStorageService } from './../../../../../../shared/services/local-storage/local-storage.service';

declare var $: any;
declare var Cropper: any;

@Component({
  selector: 'app-card-geral',
  templateUrl: './card-geral.component.html',
  styleUrls: ['./card-geral.component.scss']
})
export class CardGeralComponent implements OnInit {
  public editGeneral = false;
  public imageLoaded = false;
  public image = '';
  public cropper: any = null;
  public imageName = '';
  public croppedImage: any = null;
  public profilePicture: any = null;
  public sendingImage = false;
  public conta: IConta = new Conta();
  public cartao: ICartao = new Cartao();
  public endereco: IEndereco = new Endereco();
  public adquirentes: IAdquirente = new Adquirente();

  constructor(
    private elRef: ElementRef,
    private sanitize: DomSanitizer,
    private contaService: ContaService,
    private localStorage: LocalStorageService,
  ) { }

  ngOnInit() {
    this.getConta();
  }

  getConta() {
    const loginUser = this.localStorage.get('login');

    if (!loginUser) {
      return;
    }

    this.contaService.obterConta(loginUser.PersonId).subscribe((data: any) => {
      this.conta = data;
      this.cartao = this.cartao && this.conta.Cartoes && this.conta.Cartoes[0] ? this.conta.Cartoes[0] : this.cartao;
      this.endereco = this.endereco && this.conta.Enderecos && this.conta.Enderecos[0] ? this.conta.Enderecos[0] : this.endereco;
      if (this.conta && this.conta.LogoUrl) {
        this.profilePicture = this.sanitize.bypassSecurityTrustResourceUrl(this.conta.LogoUrl);
      }

    }, (err) => {
      console.error(err);
    });
  }

  clickImageChange() {
    this.elRef.nativeElement.querySelector('#profile-image').click();
  }

  fileChangeEvent(e: any) {
    $('#modal-upload').modal('show');

    const input = this.elRef.nativeElement.querySelector('#profile-image');

    const self = this;
    this.imageToBase64(input.files[0], function(base64) {
      const image: any = document.getElementById('image');

      setTimeout(function() {
        self.imageName = input.files[0].name;
        image.src = 'data:image/' + self.getimageExtension(input.files[0].name) + ';base64,' + base64;
    
        if (self.cropper) {
          self.cropper.destroy();
        }
    
        self.cropper = new Cropper(image, {
          aspectRatio: 3 / 2,
          crop: function() {
            this.cropper.getCroppedCanvas().toBlob((blob) => {
              self.croppedImage = blob;
            });
          }
        });
      }, 250);
    });
  }

  getimageExtension(fileName) {
    const extension = fileName.split('.')[1].toLowerCase();

    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpeg';
      case 'png':
        return 'png';
      default:
        return 'jpeg';
    }
  }

  imageToBase64(file, callback) {
    const reader = new FileReader();
    reader.onload = function(e) {
      const result: any = reader.result;

      callback(btoa(result));
    };
    reader.readAsBinaryString(file);
  }

  onImageLoad(): void {
    this.imageLoaded = true;
  }

  sendImage() {
    this.sendingImage = true;

    const user = this.localStorage.get('login');
    const formData: FormData = new FormData();

    formData.append('file', this.croppedImage, this.imageName);

    this.contaService.adicionarLogo(formData, user.PersonId).subscribe((data: any) => {
      const blob = new Blob([this.croppedImage], { type: 'image/jpeg' });
      this.profilePicture = this.sanitize.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));

      EventEmitterService
      .get('refresh-avatar')
      .emit({
        image: this.profilePicture
      });
  
      $('#modal-upload').modal('hide');
      this.sendingImage = false;
    }, (err) => {
      this.sendingImage = false;
      console.error(err);
    });
  }

  removeImage(e) {
    e.preventDefault();
    this.contaService
      .removerLogo(this.conta.ContaId)
      .subscribe(() => {
        EventEmitterService.get('remove-avatar').emit(null);
        this.profilePicture = null;
      }, (err) => {
        console.error(err);
      });
  }

  clickBtnGeral(e) {
    e.preventDefault();

    this.editGeneral ? this.salvarGeral() : this.editarGeral();
  }

  editarGeral() {
    this.editGeneral = true;
    this.elRef.nativeElement.querySelector('#card-config').classList.remove('animate-card-up-config');
    this.elRef.nativeElement.querySelector('#card-config').classList.add('animate-card-down-config');
  }

  salvarGeral() {
    this.elRef.nativeElement.querySelector('#submit-geral').classList.add('loading');

    this.conta.Validacao = {};

    if (this.conta && this.conta.Adquirentes && this.conta.Adquirentes.length > 0) {
      this.conta.Adquirentes.forEach((adquirente) => {
        adquirente.Validacao = {};
      });
    }

    if (this.conta && this.conta.Cedentes && this.conta.Cedentes.length > 0) {
      this.conta.Cedentes.forEach((cedente) => {
        cedente.Validacao = {};
      });
    }

    if (this.conta.Enderecos.length > 0) {
      this.endereco.EnderecoId = this.conta.Enderecos[0].EnderecoId;
      this.endereco.ContaId = this.conta.Enderecos[0].ContaId;
      this.conta.Enderecos[0] = this.endereco;
    } else {
      this.conta.Enderecos.push(this.endereco);
    }

    this.contaService.atualizarConta(this.conta).subscribe((data) => {
      this.editGeneral = false;

      this.elRef.nativeElement.querySelector('#card-config').classList.remove('animate-card-down-config');
      this.elRef.nativeElement.querySelector('#card-config').classList.add('animate-card-up-config');

      this.elRef.nativeElement.querySelector('#submit-geral').classList.remove('loading');
    }, (err) => {
      this.elRef.nativeElement.querySelector('#submit-geral').classList.remove('loading');
      console.error(err);
    });
  }

  mascaraCpf(valor) {
    return valor ? valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4') : '';
  }

  mascaraCnpj(valor) {
    return valor ? valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5') : '';
  }

  mascaraCep(valor) {
    return valor ? valor.replace(/(\d{5})(\d{3})/g, '\$1-\$2') : '';
  }

  mascaraTelefone(valor) {
    return valor ? this.phoneMask(valor): '';
  }

  telefoneValue(event) {
    let input = event.target
    input.value = this.phoneMask(input.value)
  }
  
  phoneMask(value) {
    if (!value) return ""
    value = value.replace(/\D/g,'')
    value = value.replace(/(\d{2})(\d)/,"($1) $2")
    value = value.replace(/(\d)(\d{4})$/,"$1-$2")
    return value
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/minha-conta/configuracoes/card-geral/card-geral.component.ts